import { RX } from '@common/RX/RX'

import StatService from '@statService/client/web/StatService'

import type { IRequest, IBaseUgyesedniAppItem } from './definitions'
import globals from './globals'

/**
 * SendStats.
 * @param userAgent - UserAgent.
 */
export default function sendStats (userAgent: string): void {
  if (RX.BOT.test(userAgent)) {
    return
  }

  // Ha NEM bot akkor küldjön fel statot.
  const startType = (
    globals.isCordova
      ? 'cordova'
      : globals.isElectron
        ? 'electron'
        : 'web'
  )

  const data: IBaseUgyesedniAppItem = {
    startType,
    serial: globals.serial,
    referrer: document.referrer,
    userAgent,
    resolution: `${ window.screen.width }x${ window.screen.height }`
  }

  const request: IRequest = {
    project: 'ugyesedniApps',
    data
  }

  StatService.send(request)
}
